import React from "react";
import { Colors } from "src/assets/colors/Colors";

export default (props) => (
    <div style={{
        position: 'absolute',
        height: '10px', 
        width: '10px',
        borderRadius: '50%',
        left: '50%',
        top: '35%',
        backgroundColor: (props.value == true || props.value == "1") ? Colors.GREEN_SWITCH_ACTIVE : Colors.RED_SWITCH_INACTIVE
    }}/>
);